import { CommonModule } from "@angular/common";
import { Component, Input, signal } from "@angular/core";
import { animate, style, transition, trigger } from "@angular/animations";
import { AiBookingCardComponent } from "../ai-booking-card/ai-booking-card/ai-booking-card.component";

@Component({
  selector: "app-ai-booking-floating-widget",
  standalone: true,
  imports: [CommonModule, AiBookingCardComponent],
  templateUrl: "./ai-booking-floating-widget.component.html",
  styleUrls: ["./ai-booking-floating-widget.component.scss"],
  animations: [
    trigger("panelAnimation", [
      transition(":enter", [
        style({
          opacity: 0,
          transform: "translateY(18px) scale(0.96)",
          filter: "blur(8px)",
        }),
        animate(
          "220ms cubic-bezier(0.2, 0.8, 0.2, 1)",
          style({
            opacity: 1,
            transform: "translateY(0) scale(1)",
            filter: "blur(0)",
          }),
        ),
      ]),
      transition(":leave", [
        animate(
          "160ms cubic-bezier(0.4, 0, 1, 1)",
          style({
            opacity: 0,
            transform: "translateY(14px) scale(0.97)",
            filter: "blur(6px)",
          }),
        ),
      ]),
    ]),
  ],
})
export class AiBookingFloatingWidgetComponent {
  @Input() locationQuery = "";
  @Input() isAuthenticated = false;

  open = signal(false);

  toggleOpen(): void {
    this.open.update((value) => !value);
  }

  close(): void {
    this.open.set(false);
  }
}
